import { createFileRoute } from '@tanstack/react-router';
import { redirectToHealthReadiness } from '@/components/health-readiness/legacy-redirect';

/**
 * The old readiness page, removed in T-0219 (T-0224, T-0242): kept as a
 * redirect so a bookmark lands on the Go-live criteria tab at the first
 * criterion.
 */
export const Route = createFileRoute('/engagements/$engagementId/readiness')({
  beforeLoad: ({ params }) => {
    throw redirectToHealthReadiness(params.engagementId, { tab: 'criteria' });
  },
});
